module.exports = __webpack_public_path__ + "ec047e80d9101ebf16a8d6e26b995745.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio5/08_5MCA The Apartment.mp3
// module id = 796
// module chunks = 0